import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	Typography,
	Button,
	Divider,
	List,
	ListItem,
	ListItemText,
	Box,
	Chip,
} from "@mui/material";
import { Close, ArrowBack, Check } from "@mui/icons-material";
import { globalFormatCurrencyBRL } from "../../../../../shared/utils";
import { format, parseISO } from "date-fns";

interface PreviewItem {
	dueDate: string;
	amount: string;
	typeAmount: string;
	obs: string;
}

interface ModalFinancialPreviewProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	items: PreviewItem[];
	lastInstallmentNumber?: number;
}

export const ModalFinancialPreview = ({ open, onClose, onConfirm, items, lastInstallmentNumber = 0 }: ModalFinancialPreviewProps) => {
	const totalAmount = items.reduce((sum, item) => sum + Number(item.amount), 0);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
				<Typography variant="h6" fontWeight={400} color="primary.main">
					Confirmar lançamentos
				</Typography>
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			</DialogTitle>

			<Divider />

			<DialogContent sx={{ px: 4, pt: 2, maxHeight: "60vh" }}>
				<Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
					<Typography fontWeight={500}>Total de parcelas: {items.length}</Typography>
					<Typography fontWeight={500}>Valor total: {globalFormatCurrencyBRL(totalAmount.toString())}</Typography>
				</Box>

				{items.length === 0 ? (
					<Typography variant="body2" color="text.secondary">
						Nenhum lançamento gerado.
					</Typography>
				) : (
					<List dense disablePadding>
						{items.map((item, index) => (
							<ListItem
								key={index}
								divider
								secondaryAction={
									<Typography variant="body2" fontWeight={500} color={item.typeAmount === "discount" ? "error.main" : undefined}>
										{item.typeAmount === "discount" ? `- ${globalFormatCurrencyBRL(item.amount)}` : globalFormatCurrencyBRL(item.amount)}
									</Typography>
								}
							>
								<ListItemText
									primary={
										item.typeAmount === "discount"
											? "Desconto"
											: item.typeAmount === "add"
											? "Acréscimo"
											: `Parcela ${lastInstallmentNumber + index + 1}`
									}
									secondary={`Vencimento: ${format(parseISO(item.dueDate), "dd/MM/yyyy")}`}
								/>
							</ListItem>
						))}
					</List>
				)}
			</DialogContent>

			<DialogActions sx={{ px: 4, pb: 3 }}>
				<Button variant="outlined" startIcon={<ArrowBack />} onClick={onClose}>
					Voltar
				</Button>
				<Button variant="contained" color="primary" startIcon={<Check />} onClick={onConfirm}>
					Confirmar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
